import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _excluded = ["id", "color", "name", "flip", "rotate", "spin", "pulse", "className", "size", "display"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import pt from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // https://www.npmjs.com/package/@fortawesome/react-fontawesome

import { Text } from '../';
import { extendProps, appendHtmlClass } from '../../js/util';
import getConfig from '../../js/settings';
import './_index.scss';
var ICON_SIZE_SCALE = getConfig('ICON_SIZE_SCALE');
var ICON_SIZE_PREFIX = getConfig('ICON_SIZE_PREFIX');
var ICON_SIZE_DEFAULT = getConfig('ICON_SIZE_DEFAULT');
var DISPLAY_TYPE_PREFIX = getConfig('DISPLAY_TYPE_PREFIX');
var DISPLAY_TYPE = getConfig('DISPLAY_TYPE');
var FLIP_TYPE = getConfig('FLIP_TYPE');
var Icon = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Icon, _React$Component);
  function Icon() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.PREFIX_MAP = {
      solid: 'fas',
      regular: 'far',
      brands: 'fab'
    };
    _this.PREFIX_MAP_DEFAULT = _this.PREFIX_MAP.solid;
    return _this;
  }
  var _proto = Icon.prototype;
  _proto.getIconFromName = function getIconFromName(prop) {
    if (!prop) return null;
    var name,
      prefix = this.PREFIX_MAP_DEFAULT;
    if (typeof prop === 'string') name = prop;else if (prop.length === 1) name = prop[0];else {
      name = prop[1];
      prefix = this.PREFIX_MAP[prop[0]];
    }
    return [prefix, name];
  };
  _proto.render = function render() {
    var _this$props = this.props,
      id = _this$props.id,
      color = _this$props.color,
      name = _this$props.name,
      flip = _this$props.flip,
      rotate = _this$props.rotate,
      spin = _this$props.spin,
      pulse = _this$props.pulse,
      className = _this$props.className,
      size = _this$props.size,
      display = _this$props.display,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var icon = this.getIconFromName(name);
    if (!icon) return null;
    var iconProps = {
      icon: icon,
      flip: flip,
      rotation: rotate ? parseInt(rotate, 10) : null,
      spin: spin,
      pulse: pulse
    };
    var cls = appendHtmlClass(className, 'icon');
    if (size) cls = appendHtmlClass(cls, "" + ICON_SIZE_PREFIX + size);
    if (display) cls = appendHtmlClass(cls, "" + DISPLAY_TYPE_PREFIX + display);
    var textProps = _objectSpread(_objectSpread({}, rest), {}, {
      className: cls,
      id: id,
      color: color
    });
    return /*#__PURE__*/React.createElement(Text, textProps, /*#__PURE__*/React.createElement(FontAwesomeIcon, iconProps));
  };
  return Icon;
}(React.Component);
Object.assign(Icon, extendProps(Text, ['className', 'id', 'color'], {
  /**
   * Name of icon. Single array item or string means using default, solid collection of icons. Two array items stand for collection (solid, regular, brand) and name of icon e.g. ['solid', 'square']
   */
  name: function name(props, propName, componentName) {
    var name = props[propName];
    var isArray = Array.isArray(name);
    var ICONS = getConfig('ICONS');
    if (typeof name !== 'string' && !isArray || isArray && (name.length <= 0 || name.length > 2) || isArray && name.length > 1 && Object.keys(ICONS).indexOf(name[0]) < 0) {
      return new Error("Invalid prop " + propName + " supplied to " + componentName + ". Validation failed.");
    }
  },
  /**
   * Size
   */
  size: pt.oneOf(ICON_SIZE_SCALE.map(function (i) {
    return i.key;
  })),
  /**
   * Flag to indicate is it block, inline element or inline block
   */
  display: pt.oneOf(Object.keys(DISPLAY_TYPE)),
  /**
   * Flip icon horizontally, vertically or both
   */
  flip: pt.oneOf(Object.keys(FLIP_TYPE)),
  /**
   * Rotate icon (degrees)
   */
  rotate: pt.oneOf([90, 180, 270]),
  /**
   * Spin icon
   */
  spin: pt.bool,
  /**
   * Pulse icon
   */
  pulse: pt.bool
}, {
  size: ICON_SIZE_DEFAULT,
  spin: false,
  pulse: false
}));
export default Icon;